/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PurchasePaidRequestDto {
  paidBy: PurchasePaidRequestDto.PaidByEnum;
  paidBankType: PurchasePaidRequestDto.PaidBankTypeEnum;
  paidSlipImageUrl: string;
  paidToMemberBankId: string;
  paidToBankId: string;
  paidToBankBranchName: string;
  paidToBankAccountNo: string;
  rememberBank: boolean;
  paidToPromptpay: string;
}
// tslint:disable-next-line:no-namespace
export namespace PurchasePaidRequestDto {
  export type PaidByEnum = 'cash' | 'bank';
  export const PaidByEnum = {
      Cash: 'cash' as PaidByEnum,
      Bank: 'bank' as PaidByEnum,
  };
  export type PaidBankTypeEnum = 'saved_account' | 'custom_account' | 'promptpay';
  export const PaidBankTypeEnum = {
      SavedAccount: 'saved_account' as PaidBankTypeEnum,
      CustomAccount: 'custom_account' as PaidBankTypeEnum,
      Promptpay: 'promptpay' as PaidBankTypeEnum,
  };
}
